import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import { CategoryArticles } from '@features/knowledge/knowledge-category-list/knowledge-category-list.component';
import { LazyAssetComponent } from '@features/lazy-image/components/lazy-asset/lazy-asset.component';
import { KnowledgeArticle } from '@generated/graphql';
import { LinkComponent } from '../../../shared/link/link.component';

import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';

@Component({
    selector: 'app-knowledge-category-list-item',
    templateUrl: './knowledge-category-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkComponent, LazyAssetComponent],
})
export class KnowledgeCategoryListItemComponent implements OnInit {
    @Input() category: CategoryArticles;
    iconUrl: string;
    assetConfiguration: AssetImageConfiguration;

    constructor(private contentfulService: ContentfulService) {}

    ngOnInit(): void {
        this.assetConfiguration = {
            image: this.category?.category.icon,
            width: 200,
        };
    }

    preloadArticle(article: KnowledgeArticle) {
        this.contentfulService.article(article.urlSlug).subscribe();
    }
}
